import { SelectDataType } from "src/components/atom/SelectDataType"
import { COUNTRIES, MEMBER_TYPE, MEMBER_TYPE_STRING } from "./const"

export const getUserType = (userType?: string) => {
  switch (userType) {
    case MEMBER_TYPE_STRING.USER:
      return MEMBER_TYPE.USER
    case MEMBER_TYPE_STRING.ADVISER:
      return MEMBER_TYPE.ADVISER
    case MEMBER_TYPE_STRING.COMPANY:
      return MEMBER_TYPE.COMPANY
    case MEMBER_TYPE_STRING.ADMINISTRATOR:
      return MEMBER_TYPE.ADMINISTRATOR
  }
  return undefined
}

export const getCareerYearRange = () => {
  let ret = []
  const currentYear = new Date().getFullYear()
  for (let i = 1950; i <= currentYear; i++) {
    ret.push(i)
  }
  return ret
}

export const getUserAttribute = (userDatas: any[], key: string) => {
  for (const userData of userDatas) {
    if (userData.Name === key) {
      return userData.Value
    }
  }
  return undefined
}

export const getCountriesForSelect = () => {
  const ret = []
  for (const country of COUNTRIES) {
    ret.push({
      label: country,
      value: country,
    })
  }
  return ret
}

export const getLabel = (datas: SelectDataType[], value: number) => {
  for (const data of datas) {
    if (data.value === value) {
      return data.label
    }
  }
  return ""
}
